import { Input } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';

import { TMarketingForm } from './MarketingPoll';
import styles from './PollOptionDetail.module.css';
import { Button } from '../Button/Button';

const PollOptionDetail = () => {
  const { register, watch } = useFormContext<TMarketingForm>();

  return (
    <section className={styles.detailedAnswerContainer}>
      <div className={styles.detailedAnswerForm}>
        <Input
          {...register('detail')}
          wrapperClassName={styles.detailedAnswerWrapper}
          label="Where else did you hear about us?"
          placeholder="e.g. Expo"
        />
        <Button
          type="submit"
          variant="primary"
          className={styles.detailedCTA}
          disabled={!watch('detail')}
        >
          Submit answer
        </Button>
      </div>
    </section>
  );
};

export default PollOptionDetail;
